module.exports = __webpack_public_path__ + "img/MGH-Gion-2-2440x1172.94b56386.jpg";